import { calculateTotals } from '../../helpers';
import { calculateFoodItemTotals } from '../../helpers/domain';

const formatMacroValue = (value) => {
    if (!value || value <= 0) return '-';
    return `${value} g`;
};

const DiarySum = ({ items = [], isExercise = false, isFoodItem = false }) => {
    const { totalKcal, totalCarbs, totalProtein, totalFat } = isFoodItem
        ? calculateFoodItemTotals(items)
        : calculateTotals(items);

    const totalKcalBurned = Math.round(items.reduce((acc, item) => acc + (item.kcal || 0), 0));

    const displayKcal = !isExercise ? totalKcal || 0 : totalKcalBurned;

    return (
        <div className={`diary-items-sum ${!isExercise ? 'meal-sum' : ''}`}>
            <div className="item-sum-top">
                <span className="total-text">Totalt:</span>
                <span className="total-kcal">{displayKcal} kcal</span>
            </div>

            {!isExercise && (
                <div className="item-sum-bottom">
                    <div>
                        <span className="bold-title">Kolhydrater</span>
                        {formatMacroValue(totalCarbs)}
                    </div>
                    <div>
                        <span className="bold-title">Protein</span>
                        {formatMacroValue(totalProtein)}
                    </div>
                    <div>
                        <span className="bold-title">Fett</span>
                        {formatMacroValue(totalFat)}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiarySum;
